export const concatStyles = (values: Array<string | false | undefined>) => {
  return values
    .filter((v) => {
      if (!v) {
        return false;
      }

      const trimmed = v.replace(/\s+/g, ' ').trim();
      if (!trimmed) {
        return false;
      }

      return true;
    })
    .join(' ');
};
